// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/Button/Button.module.scss'

// Types
interface IOnbordingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  dataCy: string
  inverted?: boolean
  icon?: React.ReactNode | null
}

const Button: React.FC<IOnbordingButtonProps> = ({
  title,
  className = '',
  dataCy,
  inverted = false,
  icon,
  ...restProps
}) => (
  <button
    type="button"
    data-cy={dataCy}
    {...restProps}
    className={clsx(
      classes.button,
      inverted ? classes.inverted : '',
      className
    )}>
    {icon}
    {title}
  </button>
)

export default Button
